import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import NoData from "../../NoData";
import { decode } from 'js-base64';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import Loading from "../../Loading";


export default function SearchHistory() {

    DataTable.use(DT);
    const [userSubscription, setUserSubscription] = useState([]);
    const authAdminToken = localStorage.getItem("authAdminToken");
    const [loading, setLoading] = useState(true);


    const { id } = useParams();
    const decode_id = decode(id);

    // View Subscription Details Section
    const fetchUserSearchHistory = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getUserSearchHistory`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${authAdminToken}`
            },
            body: JSON.stringify({ id: decode_id })
        });

        return response.json();
    };

    useEffect(() => {
        fetchUserSearchHistory().then((res) => {
            setUserSubscription(res.history);
            setLoading(false);
        }).catch((error) => {
            toast.error("Unable to load user details. Please try again later.");
        })
    }, []);

    return (
        <>
            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {loading ?
                <Loading />
                :
                <div className="container-xxl flex-grow-1 container-p-y my-5 px-3" style={{ margin: "4em 20em" }}>
                    <div className="card shadow-sm border-0">
                        <div className="card-header d-flex justify-content-between align-items-center bg-white border-bottom-0">
                            <h5 className="card-title mb-0">User Subscription History</h5>
                        </div>

                        {userSubscription.length > 0 ?

                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <DataTable data={userSubscription.map((sub, index) => {

                                        return [
                                            index + 1,
                                            sub.medium,
                                            sub.subject,
                                            sub.grade,
                                            sub.question
                                        ];
                                    })}

                                        className="display">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Medium</th>
                                                <th>Subject</th>
                                                <th>Grade</th>
                                                <th>Question</th>
                                            </tr>
                                        </thead>
                                    </DataTable>
                                </div>
                            </div>

                            // <div className="card-body p-0">
                            //     <div className="table-responsive">
                            //         <table className="table table-striped table-hover align-middle mb-0">
                            //             <thead className="table-light">
                            //                 <tr className="w-100 bg-primary fw-semibold py-2 rounded-top">
                            //                     <th scope="col" className='text-center'>#</th>
                            //                     <th scope="col" className='text-center'>Medium</th>
                            //                     <th scope="col" className='text-center'>Subject</th>
                            //                     <th scope="col" className='text-center'>Grade</th>
                            //                     <th scope="col" className='text-center'>Question</th>
                            //                 </tr>
                            //             </thead>


                            //             <tbody >

                            //                 {userSubscription.map((sub, index) => {
                            //                     return <tr scope="row" className='text-center' key={index}>
                            //                         <td className='text-center'>{index + 1}</td>
                            //                         <td className='text-center'>{sub.medium}</td>
                            //                         <td className='text-center'>{sub.subject}</td>
                            //                         <td className='text-center'>{sub.grade}</td>
                            //                         <td className='text-center'>{sub.question}</td>
                            //                     </tr>
                            //                 })}
                            //             </tbody>
                            //         </table>
                            //     </div>
                            // </div>

                            :
                            <NoData />
                        }

                    </div>
                </div>}
        </>
    )
}
